import React from 'react';
import { useTranslation } from '../../../i18n/LanguageContext';

const whatsappUrl = 'https://wa.me/916263618884?text=Hi%2C%20I%20want%20a%20demo%20of%20SpellStudy%20for%20my%20school.';

const StickyConversionCta = () => {
  const { t } = useTranslation();

  const scrollToDemo = () => {
    const el = document.getElementById('contact');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className="lp-sticky-cta">
      <button type="button" onClick={scrollToDemo}>
        <i className="fa-solid fa-calendar-check" />
        {t('landing.sticky.demo')}
      </button>
      <a href={whatsappUrl} target="_blank" rel="noopener noreferrer">
        <i className="fa-brands fa-whatsapp" />
        {t('landing.sticky.whatsapp')}
      </a>
    </div>
  );
};

export default StickyConversionCta;
